import React from 'react';

import { Checkbox } from 'react-bootstrap';

import FormField from '../FormField';

const PrivacyPolicyLink = () => (
    <a target="_blank" rel="noopener noreferrer" href="https://www.iwoca.de">
        www.iwoca.de
    </a>
);

const PrivacyPolicyAgreementDE = ({ field, onTick }) => (
    <FormField wrapperGrid={{ sm: 12 }} field={field}>
        <Checkbox
            checked={!!field.value}
            onChange={onTick}
            data-testid="privacy-policy-checkbox"
            className="legal-check legal-personal">
            <div data-testid="privacy-policy-section">
                {
                    <p>
                        Im Namen des Vollmachtgebers (wie z.B. der
                        Geschäftsführung oder des Inhabers) wird im Rahmen des
                        Antragsprozesses den geltenden AGB, dem
                        Datenschutzhinweis und dem Hinweis zum Datentransfer an
                        die Schufa Holding AG zugestimmt. Wir verwenden die
                        persönlichen Daten Ihres Kunden (und anderer
                        Geschäftsführer oder wirtschaftlicher Berechtigter des
                        Unternehmens sowie anderer bürgenden Personen) auf
                        verschiedene Weise wie z.B.:
                    </p>
                }
                <ul>
                    <li>
                        <b>
                            Wir geben sie an Kreditauskunfteien weiter, um
                            Konditionsanfragen und Identitätsprüfungen
                            durchzuführen
                        </b>{' '}
                        - Unsere Anfrage erfolgt als score-neutrale
                        Konditionsanfrage, die für andere Unternehmen nicht
                        sichtbar ist und keine dauerhafte Auswirkung auf den
                        persönlichen Schufa-Score Ihres Kunden (oder auf die
                        Bonität anderer Bürgen hat)
                    </li>
                </ul>
                <p>
                    Kreuzen Sie das Kästchen an, um fortzufahren - stellen Sie
                    sicher, dass Ihr Kunde und die anderen relevanten Personen
                    (Geschäftsführer, wirtschaftliche Berechtigte oder andere
                    bürgende Personen) hierüber informiert sind, bevor Sie dies
                    durchführen. Bitte übermitteln Sie Ihrem Kunden auch ein
                    Exemplar unserer Datenschutzerklärung. Weitere Informationen
                    zu AGBs, Datenschutz und Schufa & Crefo finden Sie auf{' '}
                    <PrivacyPolicyLink /> unter ‘Rechtliches’.
                </p>
            </div>
        </Checkbox>
    </FormField>
);

export default PrivacyPolicyAgreementDE;
